import { HOME } from "@/constants/testIds";

const TOOLS = [
  { slug: "chatgpt", name: "ChatGPT by OpenAI", w: 116 },
  { slug: "claude", name: "Claude", w: 127 },
  { slug: "gemini", name: "Gemini", w: 128 },
  { slug: "grok", name: "Grok", w: 93 },
  { slug: "copilot", name: "Microsoft Copilot", w: 103 },
  { slug: "perplexity", name: "Perplexity", w: 147 },
  { slug: "mistral", name: "Mistral AI", w: 164 },
  { slug: "deepseek", name: "DeepSeek", w: 161 },
  { slug: "metaai", name: "Meta AI", w: 131 },
];

const Logo = ({ t, decorative }) => (
  <li className="shrink-0">
    <img src={`/brand/ai/${t.slug}.svg`} alt={decorative ? "" : t.name} width={t.w} height={24} loading="lazy"
      className="h-[22px] w-auto opacity-55 sm:h-[26px]" />
  </li>
);

export default function AIToolsStrip() {
  return (
    <section aria-labelledby="ai-tools-label" data-testid={HOME.aiTools} className="relative pb-16 sm:pb-24">
      <span aria-hidden className="mx-auto mb-14 block h-px w-[calc(100%-48px)] max-w-[580px] bg-fg/20" />
      <p id="ai-tools-label" className="mx-auto max-w-xl px-6 text-center text-[15px] font-light text-fg/85 sm:text-[17px]">
        We help your business or organization get the most out of AI.
      </p>
      <p className="mt-2 px-6 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-subtle/80">
        The best AI tools. These and beyond, put to work for your business.
      </p>
      <div className="fa-marquee fa-marquee--reverse mt-10 py-2">
        <div className="fa-marquee-track">
          <ul className="fa-marquee-group fa-logo-group" aria-label="AI tools">
            {TOOLS.map((t) => <Logo key={t.slug} t={t} />)}
          </ul>
          <ul className="fa-marquee-group fa-logo-group fa-marquee-dup" aria-hidden="true" inert>
            {TOOLS.map((t) => <Logo key={t.slug} t={t} decorative />)}
          </ul>
        </div>
      </div>
    </section>
  );
}
